(function () {
  var STICKY_SELECTOR = '.sticky-bar, .acc-shred__sticky, [class*="ai-hero-sticky-cta-wrap-"]';
  var OFFER_ID = 'acc-shred-offer';
  var SHRED_SECTION_SELECTOR = '.acc-shred-section';
  var shredSectionTicking = false;
  var stickyResizeObserver = null;
  var stickyMutationObserver = null;

  function getFixedStickyElements() {
    return Array.prototype.filter.call(document.querySelectorAll(STICKY_SELECTOR), function (element) {
      return window.getComputedStyle(element).position === 'fixed';
    });
  }

  function isStickyActive(element) {
    var styles = window.getComputedStyle(element);
    if (styles.display === 'none' || styles.visibility === 'hidden' || parseFloat(styles.opacity) === 0) return false;

    if (element.classList.contains('acc-shred__sticky')) {
      return element.classList.contains('is-visible');
    }

    if (element.classList.contains('sticky-bar')) {
      return element.classList.contains('visible');
    }

    if (element.className.indexOf('ai-hero-sticky-cta-wrap-') !== -1) {
      return element.classList.contains('is-visible')
        && !document.body.classList.contains('acc-shred-section-in-view');
    }

    return true;
  }

  function updateStickyClearance() {
    var main = document.getElementById('MainContent');
    var stickyElements = getFixedStickyElements().filter(isStickyActive);
    if (!main || !document.body) return;

    var stickyHeight = stickyElements.reduce(function (height, element) {
      return Math.max(height, element.getBoundingClientRect().height);
    }, 0);

    document.body.classList.toggle('has-fixed-sticky-cta', stickyHeight > 0);

    if (stickyHeight > 0) {
      main.style.setProperty('--fixed-sticky-cta-height', stickyHeight + 'px');
    } else {
      main.style.removeProperty('--fixed-sticky-cta-height');
    }
  }

  function observeStickySizes() {
    if (!('ResizeObserver' in window)) return;

    if (!stickyResizeObserver) {
      stickyResizeObserver = new ResizeObserver(updateStickyClearance);
    } else {
      stickyResizeObserver.disconnect();
    }

    getFixedStickyElements().forEach(function (element) {
      stickyResizeObserver.observe(element);
    });
  }

  function observeStickyVisibility() {
    if (!('MutationObserver' in window)) return;

    if (!stickyMutationObserver) {
      stickyMutationObserver = new MutationObserver(updateStickyClearance);
    } else {
      stickyMutationObserver.disconnect();
    }

    getFixedStickyElements().forEach(function (element) {
      stickyMutationObserver.observe(element, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function setShredSectionInView(isInView) {
    if (!document.body) return;
    document.body.classList.toggle('acc-shred-section-in-view', isInView);
    updateStickyClearance();
  }

  function sectionBlocksHeroSticky(section) {
    var rect = section.getBoundingClientRect();
    var passedRatio = rect.height > 0 ? Math.max(0, -rect.top / rect.height) : 1;

    return rect.top <= window.innerHeight && rect.bottom > 0 && passedRatio < 0.6;
  }

  function updateShredSectionState() {
    var sections = document.querySelectorAll(SHRED_SECTION_SELECTOR);
    var shouldHide = Array.prototype.some.call(sections, sectionBlocksHeroSticky);

    setShredSectionInView(shouldHide);
  }

  function requestShredSectionUpdate() {
    if (shredSectionTicking) return;
    shredSectionTicking = true;
    window.requestAnimationFrame(function () {
      shredSectionTicking = false;
      updateShredSectionState();
    });
  }

  function handleOfferScrollClick(event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var eventTarget = event.target instanceof Element ? event.target : null;
    var link = eventTarget && eventTarget.closest('a[href="#' + OFFER_ID + '"]');
    var offer = document.getElementById(OFFER_ID);
    if (!link || !offer) return;

    event.preventDefault();
    offer.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  }

  function refreshStickyCtas() {
    updateStickyClearance();
    observeStickySizes();
    observeStickyVisibility();
    updateShredSectionState();
  }

  function bootStickyCtas() {
    refreshStickyCtas();
    window.requestAnimationFrame(refreshStickyCtas);
    window.setTimeout(refreshStickyCtas, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStickyCtas, { once: true });
  } else {
    bootStickyCtas();
  }

  window.addEventListener('scroll', requestShredSectionUpdate, { passive: true });
  window.addEventListener('resize', function () {
    updateStickyClearance();
    requestShredSectionUpdate();
  }, { passive: true });
  document.addEventListener('click', handleOfferScrollClick);
  document.addEventListener('shopify:section:load', refreshStickyCtas);
  document.addEventListener('shopify:section:unload', refreshStickyCtas);
})();
